/**
 * This enum stores the possible values that a researcher can have
 */
export enum ResearcherStatus {
  SIGNED_UP = 'SIGNED_UP',
  DRAFT_REG = 'DRAFT_REG',
  REG_SUBMIT = 'REG_SUBMIT',
  REG_REVIEW = 'REG_REVIEW',
  INFO_AWAIT = 'INFO_AWAIT',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  BLACKLISTED = 'BLACKLISTED',
  INACTIVE_TEMP = 'INACTIVE_TEMP',
  INACTIVE_PERM = 'INACTIVE_PERM',
  INVALID = 'INVALID',
  REG_RE_SUBMIT = 'REG_RE_SUBMIT',
  RE_CHECK = 'RE_CHECK'
}
